import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnBlockValue,
  returnUserContent,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

const ListOfThings = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)
  // user contents
  const [getUserContents, setUserContents] = useAtom(userContents)

  // example update user contents
  function updateUserContent(key, newValue) {
    const nextState = produce(getUserContents, draft => {
      draft[id][key] = newValue
    })
    setUserContents(nextState)
  }

  return (
    <div>
      {/* example of returning value - content */}
      <div className="font-bold text-2xl mb-3">
        {returnBlockValue('headline', 'content', opBlocks[block], content)}
      </div>

      <div className="space-y-3 bg-white shadow-xl mb-5 rounded p-6">
        {/* repeatable content example */}

        {returnBlockValue(
          'list_of_things',
          'content',
          opBlocks[block],
          content
        ).map((block, index) => (
          <div key={index} className="">
            <h4>{block.text}</h4>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ListOfThings
